import { BaseModel } from "model/BaseModel";

export default class UnidadeOrganizacional implements BaseModel {
    aliquotaPisPadrao?: number | null;
    aliquotaCofinsPadrao?: number | null;

    id: number | null;
    codigo: string | null;
    codigoInterno: number;
    nome: string;
    ativa: boolean = true;
    estabelecimentoFiscal: boolean = false;
    emiteNfe: boolean = false;
    razaoSocial: string | null = null;
    nomeFantasia: string | null = null;
    cnpj: string | null = null;
    inscricaoEstadual: string | null = null;
    inscricaoMunicipal: string | null = null;
    regimeTributario: string | null = null;
    regimeApuracaoIrpj: 'LUCRO_REAL' | 'LUCRO_PRESUMIDO' | null = null;
    regimePisCofins: 'CUMULATIVO' | 'NAO_CUMULATIVO' | 'MISTO' | null = null;
    vigenciaTributaria: string | null = null;
    emailFiscal: string | null = null;
    telefone: string | null = null;
    logradouro: string | null = null;
    numeroEndereco: string | null = null;
    complemento: string | null = null;
    bairro: string | null = null;
    municipio: string | null = null;
    codigoMunicipioIbge: string | null = null;
    uf: string | null = null;
    cep: string | null = null;
    codigoPaisBacen: string | null = "1058";
    pais: string | null = "BRASIL";

    constructor(
        id = 0,
        codigo = null,
        codigoInterno = 0,
        nome = ''
    ) {
        this.id = id;
        this.codigo = codigo;
        this.codigoInterno = codigoInterno;
        this.nome = nome;
    }
}
